import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=f80d10e0&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=f80d10e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80d10e0",
  null
  
)

export default component.exports